import { userStore } from "@/stores/modules/user";

export class Socket {
  url = process.env.VUE_APP_NOTICE_WS;
  socket: WebSocket;
  HEART_CHECK_TIME = 1000;
  constructor() {
    const userState = userStore();
    this.url += `?userId=${userState.userInfo.userId}&terminalId=${userState.userInfo.userId}1f085db488873`;
    this.socket = new WebSocket(this.url);
    // this.socket.onopen = (e: Event) => this.onopen.apply(this, [e]);
    // this.socket.onmessage = (e: Event) => this.onmessage.apply(this, [e]);
  }
  onopen(e: Event): any {
    this.socket.send("heartcheck");
    // setInterval(() => {
    //   this.socket.send("heartcheck");
    // }, this.HEART_CHECK_TIME);
  }

  onmessage(e: Event) {
    console.log("message:", e);
  }
}

// let socket = new WebSocket(
//   `ws://192.168.0.158:8988/ieds-back/ws/liveness?userId=${userState.userInfo.userId}&terminalId=34db6fa80a303255f8653b5beae1f085db488873`
// );

// socket.onopen = function (e) {
//   console.log(e);
//   socket.send("heartcheck");
//   setInterval(() => {
//     socket.send("heartcheck");
//   }, 10000);
// };

// socket.onmessage = function (event) {
//   console.log("message:", event.data);
// };

// socket.onclose = function (event) {
//   console.log(event);
//   if (event.wasClean) {
//     console.log(
//       `[close] Connection closed cleanly, code=${event.code} reason=${event.reason}`
//     );
//   } else {
//     // 例如服务器进程被杀死或网络中断
//     // 在这种情况下，event.code 通常为 1006
//     console.log("[close] Connection died");
//   }
// };
// socket.onerror = function (error: any) {
//   console.log(`[error] ${error.message}`);
// };
